import { render, staticRenderFns } from "./ClaimDistribution.vue?vue&type=template&id=7f2e250c&scoped=true"
import script from "./ClaimDistribution.vue?vue&type=script&lang=js"
export * from "./ClaimDistribution.vue?vue&type=script&lang=js"
import style0 from "./ClaimDistribution.vue?vue&type=style&index=0&id=7f2e250c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e250c",
  null
  
)

export default component.exports